import React from 'react';
import PropTypes from 'prop-types';

import { FormattedHTMLMessage } from 'component-utilities/intl';
import displayName from 'component-lib/displayName';
import styles from '../Dropdowns.scss';

function ExportText({ messageKey, size, text }) {
    return (<FormattedHTMLMessage
        id={messageKey}
        values={{
            baseClassName: styles[`export-text-${size}`],
            ...text,
        }}
    />)
}

ExportText.displayName = displayName('Dropdowns/Export/ExportText');

ExportText.propTypes = {
    messageKey: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['small', 'regular', 'large']).isRequired,
    text: PropTypes.object,
};

ExportText.defaultProps = {
    text: {},
};

export default ExportText;
